/**달력 관련 */
export const DATE_LOCALIZATION = {
  nextMonthCaption: '다음 달',
  prevMonthCaption: '이전 달',
  setTimeCaption: '시간 설정',
  weekdays: ['월', '화', '수', '목', '금', '토', '일'],
  months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
};

export const EXP_DIV_CODE = {
  child: '01',
  teen: '02',
  course: '03',
  makive: '09',
  event: '08',
  skill: '10',
  //onJob: '20',
  future: '20',
};
